/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */
import React, { useState } from "react";

import { Card, Button, List, ListItem, TextField, ListSubheader, ListItemText } from "@material-ui/core";
import { ConfirmDialog } from "../../../../../components/ConfirmDialog/ConfirmDialog";

/**
 * This component display the list of all roles.
 */
export const RoleList = ({
	selectRole,
	createNewRole,
	filteredRolesList,
	selectedRoleId,
	formEdited,
	onSearchTermChange,
	searchTermLabel,
	searchTerm,
}) => {
	const [editConfirmOpen, setEditConfirmOpen] = useState(false);
	const [selectedRole, setSelectedRole] = useState(null);

	return (
		<Card style={{ minHeight: 600, height: "100%", padding: "10px 5px" }}>
			<List
				component="nav"
				subheader={
					<ListSubheader disableSticky component="div">
						<TextField
							style={{ width: "100%" }}
							size="small"
							label={searchTermLabel}
							value={searchTerm}
							onChange={(e) => onSearchTermChange(e.target.value)}
						/>
						<div className="d-flex flex-row justify-content-between align-items-center flex-wrap">
							<span>Roles</span>
							<Button className="mb-md-0" variant="outlined" size="small" disabled={formEdited} onClick={createNewRole}>
								Add
							</Button>
						</div>
					</ListSubheader>
				}
			>
				{filteredRolesList &&
					(filteredRolesList.length > 0 ? (
						filteredRolesList.map((role) => (
							<ListItem
								key={role.roleId}
								selected={role.roleId === selectedRoleId}
								button
								onClick={() => {
									if (formEdited) {
										setSelectedRole(role);
										setEditConfirmOpen(true);
									} else {
										selectRole(role);
									}
								}}
							>
								<ListItemText
									style={{ overflowWrap: "break-word" }}
									primary={role.roleName}
									secondary={role.default ? "Default" : ""}
								/>
							</ListItem>
						))
					) : (
						<div style={{ margin: "auto", textAlign: "center", color: "gray" }}>{"No Roles Found"}</div>
					))}
			</List>
			<ConfirmDialog
				title={"Switch Role?"}
				message={"You have unsaved changes that will be discarded if you proceed. Are you sure?"}
				confirmOpen={editConfirmOpen}
				onClose={async (confirmed) => {
					if (confirmed && selectedRole) {
						selectRole(selectedRole);
					}
					setEditConfirmOpen(false);
				}}
			/>
		</Card>
	);
};
